export const TEXT_LIST = 'TEXT_LIST';
export const CHICLET_LIST = 'CHICLET_LIST';
export const ASSOCIATION_CHICLET_LIST = 'ASSOCIATION_CHICLET_LIST';
export const SPINNER = 'SPINNER';
export const DEFAULT_SPINNER_HEIGHT = 28;
export const DEFAULT_LOADING_COMPONENT_PROPS = [{
  type: SPINNER,
  minHeight: DEFAULT_SPINNER_HEIGHT
}];